import { render, staticRenderFns } from "./Subscription.vue?vue&type=template&id=8c50a984&scoped=true"
import script from "./Subscription.vue?vue&type=script&lang=js"
export * from "./Subscription.vue?vue&type=script&lang=js"
import style0 from "./Subscription.vue?vue&type=style&index=0&id=8c50a984&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c50a984",
  null
  
)

export default component.exports